var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.417 12.167V32.47H32.72V12.167H12.417ZM10.7503 7.16699C8.90938 7.16699 7.41699 8.65938 7.41699 10.5003V34.1367C7.41699 35.9776 8.90938 37.47 10.7503 37.47H34.3867C36.2276 37.47 37.72 35.9776 37.72 34.1367V10.5003C37.72 8.65938 36.2276 7.16699 34.3867 7.16699H10.7503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.417 48.5303V68.8333H32.72V48.5303H12.417ZM10.7503 43.5303C8.90938 43.5303 7.41699 45.0227 7.41699 46.8636V70.5C7.41699 72.3409 8.90938 73.8333 10.7503 73.8333H34.3867C36.2276 73.8333 37.72 72.3409 37.72 70.5V46.8636C37.72 45.0227 36.2276 43.5303 34.3867 43.5303H10.7503Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7803 12.167V32.47H69.0833V12.167H48.7803ZM47.1136 7.16699C45.2727 7.16699 43.7803 8.65938 43.7803 10.5003V34.1367C43.7803 35.9776 45.2727 37.47 47.1136 37.47H70.75C72.5909 37.47 74.0833 35.9776 74.0833 34.1367V10.5003C74.0833 8.65938 72.5909 7.16699 70.75 7.16699H47.1136Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7803 48.5303V68.8333H69.0833V48.5303H48.7803ZM47.1136 43.5303C45.2727 43.5303 43.7803 45.0227 43.7803 46.8636V70.5C43.7803 72.3409 45.2727 73.8333 47.1136 73.8333H70.75C72.5909 73.8333 74.0833 72.3409 74.0833 70.5V46.8636C74.0833 45.0227 72.5909 43.5303 70.75 43.5303H47.1136Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryActive);
export default __webpack_public_path__ + "static/media/gallery-active.00624524f9b26202c596ef805cc46110.svg";
export { ForwardRef as ReactComponent };